(function FitBuilderIndex($, Adzuki)
{
	"use strict";

	var $modal = $(".modal");

	$(document).ready(function documentReady()
	{
		var component_details_pages = [
			'FitBuilders/createReservation',
		];

		Adzuki.onload(['/FitBuilders/index/'], function onload() {
			$('#fit-builder-sort').change(function _sortFitBuilder() {
				$('#fitbuildersearch-sort_by').val($(this).val());
				$('.fit-filter-btn').trigger('click');
			});
		});

		Adzuki.onload(component_details_pages, function onload()
		{
			$('.components').on('click', '.component-details', function showComponentDetails(e)
			{
				var component_id = $(this).data('component_id');

				e.preventDefault();

				$modal.find('.modal-body').text('Loading component details...');
				$modal.find('.modal-title').text('COMPONENT DETAILS');
				$modal.modal('show');

				Adzuki.Ajax.get('/FitBuilders/componentDetailsModal/' + component_id)
				.then(function showDetails(data) {
					$modal.find('.modal-body').html(data);
				});
			});
		});
	});
}(jQuery, window.Adzuki || {}));
